<template>
  <div class="nre-barcode-container">
    <!-- Primo codice a barre -->
    <div class="barcode-block">
      <!--<canvas ref="barcode1"></canvas>-->
      <svg class="barcode1"
        jsbarcode-format="code128"
        :jsbarcode-value="nrePart1"
        jsbarcode-textmargin="0"
        jsbarcode-margin="0"
        jsbarcode-width="2.2"
        jsbarcode-height="40"
        jsbarcode-displayvalue=false
        jsbarcode-fontoptions="bold">
      </svg>      
      <div class="barcode-text">*{{ nrePart1 }}*</div>
    </div>

    <!-- Secondo codice a barre -->
    <div class="barcode-block">
      <!--<canvas ref="barcode2"></canvas>-->
      <svg class="barcode2"
        jsbarcode-format="code128"
        :jsbarcode-value="nrePart2"
        jsbarcode-textmargin="0"
        jsbarcode-margin="0"
        jsbarcode-width="2.2"
        jsbarcode-height="40"
        jsbarcode-displayvalue=false
        jsbarcode-fontoptions="bold">
      </svg>        
      <div class="barcode-text">*{{ nrePart2 }}*</div>
    </div>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode';

export default {
  name: 'NreBarcode',
  props: {
    nre: {
      type: String,
      required: true
    }
  },
  computed: {
    nrePart1() {
      return this.nre.slice(0, 5);
    },
    nrePart2() {
      return this.nre.slice(5);
    }
  },
  mounted() {
    JsBarcode(".barcode1").init();
    JsBarcode(".barcode2").init();
    JsBarcode(this.$refs.barcode1, this.nrePart1, {
      format: "CODE128",
      height: 40, // 8mm
      width: 2,
      displayValue: false,
      margin: 0
    }).options({font: "monospace"});

    JsBarcode(this.$refs.barcode2, this.nrePart2, {
      format: "CODE128",
      height: 40,
      width: 2,
      displayValue: false,
      margin: 0
    }).options({font: "monospace"});
  }
};
</script>

<style scoped>
.nre-barcode-container {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
}

</style>
